
import React, { createContext, useContext, useState, ReactNode } from 'react';
// Corrected the import path to use data/locales.ts which exports the translations object
import { translations } from '../data/locales';

type Language = 'en' | 'de';

type TranslationKeys = keyof typeof translations.en;

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: TranslationKeys) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('octosuite_lang');
    return (saved as Language) || 'en';
  });

  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang);
    localStorage.setItem('octosuite_lang', lang);
  };

  const t = (key: TranslationKeys): string => {
    // Accessing the appropriate translation data based on selected language
    const langData = translations[language] as Record<string, string>;
    const enData = translations.en as Record<string, string>;
    
    // Fix: cast 'key' to any to bypass symbol indexing error and use String() for fallback return to satisfy string return type
    return langData[key as any] || enData[key as any] || String(key);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: handleSetLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useTranslation must be used within a LanguageProvider');
  return context;
};
